import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomepageRoyalWelcomeHub from './pages/homepage-royal-welcome-hub';
import AboutDynastyBrandHeritage from './pages/about-dynasty-brand-heritage';
import GamesShowcaseGamingPalace from './pages/games-showcase-gaming-palace';
import VIPContactSuiteWhatsAppHub from './pages/vip-contact-suite-whats-app-hub';
import SuccessStoriesGallery from './pages/success-stories-gallery-winner-showcase';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomepageRoyalWelcomeHub />} />
        <Route path="/homepage-royal-welcome-hub" element={<HomepageRoyalWelcomeHub />} />
        <Route path="/about-dynasty-brand-heritage" element={<AboutDynastyBrandHeritage />} />
        <Route path="/games-showcase-gaming-palace" element={<GamesShowcaseGamingPalace />} />
        <Route path="/vip-contact-suite-whats-app-hub" element={<VIPContactSuiteWhatsAppHub />} />
        <Route path="/success-stories-gallery-winner-showcase" element={<SuccessStoriesGallery />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
